/** @format */
import { css } from 'styled-components';

import { mobile } from '@toucan/helpers/media-queries';

import { ConditionModalContentProps } from './index';

/**
 * Base styles for the condition modal content component
 *
 * @param {ConditionModalContentProps} props The condition modal content properties object
 * */
const baseStyles = (props: ConditionModalContentProps) => css`
    h1,
    h2,
    h3,
    h4,
    h5 {
        text-align: center;
    }

    ul {
        margin: 0 0 1rem;
        padding: 0;
        list-style: none;
        text-align: left;
        column-count: 2;
        column-gap: var(--layout-spacing-48);

        p {
            margin: 0;
        }
    }

    li {
        margin-bottom: var(--layout-spacing-24);
        font-size: 1.2rem;
        color: var(--colors-text-primary);
        page-break-inside: avoid;
        break-inside: avoid-column;
    }

    strong,
    b {
        font-size: 1.6rem;
        display: block;
        color: var(--colors-text-secondary);
    }

    .modal-button {
        margin-top: 2.6rem;
    }

    .modal-button-container {
        text-align: center;
    }

    ${mobile(css`
        ul {
            column-count: 1;
        }
    `)}
`;

/**
 * The condition modal content component styles
 *
 * @param {ConditionModalContentProps} props The condition modal content properties object
 * */
export const styles = (props: ConditionModalContentProps) => css`
    ${baseStyles(props)}
`;
